import React, { useContext, useEffect, useState } from 'react';
import { ZdsBreadcrumb, ZdsBreadcrumbs } from '@zig-design-system/ui-components-react';
import { useParams } from 'react-router-dom';
import Node from './Node';
import ApiService from '../services/ApiService';
import { RootContext } from '../../Context/RootContext';
import Translation from '../../Shared/components/Translation';
import { renderToString } from 'react-dom/server';
const Breadcrumb = ({ id }) => {
    const [breadcrumb, setBreadcrumb] = useState(null);
    const apiService = new ApiService(useContext(RootContext));
    useEffect(() => {
        apiService.getBreadcrumb(id).then((breadcrumbResponse) => {
            setBreadcrumb(breadcrumbResponse);
        });
    }, [id]);
    return (React.createElement("div", { className: "zds-margin-bottom-8 zds-hidden sm:zds-block rs_skip" },
        React.createElement(ZdsBreadcrumbs, null, breadcrumb === null || breadcrumb === void 0 ? void 0 : breadcrumb.map((part, index) => (React.createElement(React.Fragment, { key: index },
            index == 0 && (React.createElement(ZdsBreadcrumb, { link: '#/' }, renderToString(React.createElement(Translation, { item: "overview", asString: true })))),
            index > 0 && React.createElement(ZdsBreadcrumb, { link: '#/node/' + part.uid }, part.title)))))));
};
const FullContent = () => {
    const { id } = useParams();
    return (React.createElement("div", null,
        React.createElement(Breadcrumb, { id: parseInt(id) }),
        React.createElement("div", { className: 'no-indentation' },
            React.createElement(Node, { startNodeId: parseInt(id), subnodesAreLinks: true }))));
};
export default FullContent;
